import {forwardRef, MouseEvent, ReactNode} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {Spinner} from "@/shared/ui/feedback/spinner";
import {getStaticPathIcon} from "@/shared/utils/get-static-path-icon";

import "./styles/select-trigger.scss";

interface SelectTriggerProps {
    isOpen: boolean;
    disabled: boolean;
    hasError: boolean;
    displayValue: string;
    icon?: ReactNode;
    isLoading?: boolean;
    hasClearButton: boolean;
    onToggle: () => void;
    onClear: (e: MouseEvent<HTMLDivElement>) => void;
}

export const SelectTrigger = forwardRef<HTMLButtonElement, SelectTriggerProps>(
    ({isOpen, disabled, hasError, displayValue, icon, isLoading, hasClearButton, onToggle, onClear}, ref) => {
        return (
            <button
                ref={ref}
                type="button"
                onClick={onToggle}
                disabled={disabled}
                className={`select-field__trigger ${hasError ? "has-error" : ""} ${isOpen ? "is-open" : ""}`}
            >
                <div className="select-field__content">
                    {icon && <div className="select-field__icon">{icon}</div>}
                    <span className="select-field__value">{displayValue}</span>
                </div>

                <div className="select-field__icons">
                    {hasClearButton && (
                        <div role="button" tabIndex={0} onClick={onClear} className="select-field__clear" aria-label="Clear">
                            ×
                        </div>
                    )}
                    {isLoading ? (
                        <Spinner size="small" />
                    ) : (
                        <SmartImage
                            src={getStaticPathIcon("chevron-down")}
                            alt="Toggle"
                            width={16}
                            height={16}
                            className={`select-field__arrow ${isOpen ? "is-open" : ""}`}
                        />
                    )}
                </div>
            </button>
        );
    },
);

SelectTrigger.displayName = "SelectTrigger";
